// src/api/companies.js
import { authFetch } from './interceptors';

export const companiesService = {
  	// Obtener lista de empresas
  	getCompanies: async (filters = {}) => {
		try {
			//console.log('🏢 Obteniendo lista de empresas...', filters);
		
			// Construir query params para filtros
			const queryParams = new URLSearchParams();
			if (filters.nombre) queryParams.append('nombre', filters.nombre);
			if (filters.nit) queryParams.append('nit', filters.nit);
			if (filters.email) queryParams.append('email', filters.email);
			if (filters.orden) queryParams.append('orden', filters.orden);
		
			const queryString = queryParams.toString();
			const url = `/api/company/v1/empresas/${queryString ? `?${queryString}` : ''}`;
		
			const response = await authFetch(url, {
				method: 'GET',
			});
		
			//console.log('✅ Empresas obtenidas:', response);
			return response.data; // Asumiendo que response tiene {success: true, data: [...]}
		} catch (error) {
			//console.error('❌ Error obteniendo empresas:', error);
			throw error;
		}
  	},

  	// Obtener una empresa por NIT
  	getCompanyByNit: async (nit) => {
    	try {
      		//console.log('🏢 Obteniendo empresa por NIT...', nit);
      
			const empresa = await authFetch(`/api/company/v1/empresas/${nit}/`, {
				method: 'GET',
      		});
      
      		//console.log('✅ Empresa obtenida:', empresa);
      		return empresa.data;
		} catch (error) {
      		//console.error('❌ Error obteniendo empresa:', error);
      		throw error;
    	}
  	},

  	// Crear una nueva empresa
  	createCompany: async (companyData) => {
    	try {
      		//console.log('🏢 Creando nueva empresa...', companyData);
      
      		const newCompany = await authFetch('/api/company/v1/empresas/', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(companyData),
      		});
      
      		//console.log('✅ Empresa creada:', newCompany);
      		return newCompany.data;
		} catch (error) {
      		//console.error('❌ Error creando empresa:', error);
      		throw error;
    	}
  	},

  	// Actualizar una empresa
  	updateCompany: async (nit, companyData) => {
    	try {
      		//console.log('🏢 Actualizando empresa...', nit, companyData);
      
			const updatedCompany = await authFetch(`/api/company/v1/empresas/${nit}/`, {
				method: 'PATCH',
        		headers: {
          			'Content-Type': 'application/json',
        		},
        		body: JSON.stringify(companyData),
      		});
      
      		//console.log('✅ Empresa actualizada:', updatedCompany);
      		return updatedCompany.data;
		} catch (error) {
      		//console.error('❌ Error actualizando empresa:', error);
      		throw error;
    	}
  	},

  	// Eliminar una empresa (soft delete)
  	deleteCompany: async (nit) => {
    	try {
      		//console.log('🏢 Eliminando empresa...', nit);
      
      		const response = await authFetch(`/api/company/v1/empresas/${nit}/`, {
        		method: 'DELETE',
      		});
      
      		//console.log('✅ Empresa eliminada:', response);
      		return response;
    	} catch (error) {
      		//console.error('❌ Error eliminando empresa:', error);
      		throw error;
		}
  	}
};
